import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href: string;
  size?: 'md' | 'block';
  className?: string;
};
export function CtaButton({
  children,
  href,
  size = 'block',
  className = ''
}: CtaButtonProps) {
  const sizes = {
    md: 'px-6 py-3.5',
    block: 'w-full px-5 py-4 sm:py-[1.1rem]'
  };
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-rose-deep text-center font-sans text-[0.86rem] font-extrabold tracking-[0.02em] text-white shadow-[0_10px_24px_-8px_rgba(143,70,73,0.55)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-rose-darker active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rose-deep sm:text-base ${sizes[size]} ${className}`} data-id="element-59" data-mp="cn5cnbf8mf1a">
      {children}
      <ArrowRightIcon className="hidden h-4 w-4 flex-none transition-transform min-[400px]:block duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-60" data-mp="15b1709hc3uuw" />
    </a>;
}